// extracted by mini-css-extract-plugin
export var accordion = "accordion-module--accordion--t92Sy";
export var accordionContent = "accordion-module--accordionContent--ewZJw";
export var accordionIcon = "accordion-module--accordionIcon--88XSk";
export var accordionSection = "accordion-module--accordionSection--C14aa";
export var accordionText = "accordion-module--accordionText--tZz8C";
export var accordionTitle = "accordion-module--accordionTitle--w4+CG";
export var active = "accordion-module--active--k4pn7";
export var rotate = "accordion-module--rotate--jMIwG";